export enum EnumPipe {
    Boolean = 1,
    Enum = 2,
    Date = 3,
    Time = 4
}